/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Register locale data for all supported locales so Angular pipes (number, date, etc.)
// can format values correctly per build locale.
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeZh from '@angular/common/locales/zh';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeEl from '@angular/common/locales/el';
import localePl from '@angular/common/locales/pl';
import localeSv from '@angular/common/locales/sv';
import localeFi from '@angular/common/locales/fi';
import localeDa from '@angular/common/locales/da';
import localeCs from '@angular/common/locales/cs';
import localeSk from '@angular/common/locales/sk';
import localeHu from '@angular/common/locales/hu';
import localeRo from '@angular/common/locales/ro';

registerLocaleData(localeEn);
registerLocaleData(localeDe);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeZh);
registerLocaleData(localeIt);
registerLocaleData(localePt);
registerLocaleData(localeEl);
registerLocaleData(localePl);
registerLocaleData(localeSv);
registerLocaleData(localeFi);
registerLocaleData(localeDa);
registerLocaleData(localeCs);
registerLocaleData(localeSk);
registerLocaleData(localeHu);
registerLocaleData(localeRo);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
